import React from 'react'

export default function Contact() {
    return (
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "40px 20px" }}>
            <h1>Kapcsolat</h1>
            <p>Email : info@focifanatik.hu</p>
        </div>
    )
}
